// extracted by mini-css-extract-plugin
module.exports = {"container":"Polka_container__3G65s","block":"Polka_block__3NMmF","icon":"Polka_icon__3gFI9","text":"Polka_text__l91A1","button":"Polka_button__1arnb","dll":"Polka_dll__yIGef"};